import { FC } from 'react'
import { PublicTenantLogo, TenantLogo } from 'react-common'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

type TenantLogoPluginComponentProps = {
  mode?: 'public' | 'logged'
  link?: string
  isHamburger?: boolean
}

export const TenantLogoPluginComponent: FC<TenantLogoPluginComponentProps> = ({
  mode = 'logged',
  link,
  isHamburger,
}) => {
  const logo = () =>
    mode === 'logged' ? <TenantLogo isHamburger={isHamburger} /> : <PublicTenantLogo isHamburger={isHamburger} />

  const { t } = useTranslation()

  if (!link) {
    return <>{logo()}</>
  }

  return (
    <Link to={link} title={t('learnerPortal')}>
      <>{logo()}</>
    </Link>
  )
}
